<div mat-dialog-title>Select account type<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
    <div>
        <div style="margin-bottom: 10px;">Please select account type for which you want to add
            "{{alternateSecurity.securitySymbol}}" symbol
        </div>
    </div>
    <div>
        <div class="security-alternatives-container-element">
            <div class="security-alternatives-element-input">
                <p-radioButton name="INVERSE_ACCOUNT_TYPE" value="QUALIFIED" [(ngModel)]="selectedInverseAccountType" inputId="iatitem1"></p-radioButton>
                <label for="iatitem1">Qualified</label>
                <p-radioButton name="INVERSE_ACCOUNT_TYPE" value="TAXABLE" [(ngModel)]="selectedInverseAccountType" inputId="iatitem2"></p-radioButton>
                <label for="iatitem2">Taxable</label>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
        <button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
    <button class="btn-medium-primary green" (click)="onContinue()" [disabled]="!selectedInverseAccountType">
        Continue
    </button>
</mat-dialog-actions>
